// extracted by mini-css-extract-plugin
module.exports = {"segmented-tabs":"segmented-tabs___lVQ9U","tab":"tab___3V1ba","active":"active___QXFdJ","tab-label":"tab-label___1TWt4","counter-badge":"counter-badge___3Yjxw"};